<template>
  <div class="search-result">
    <div class="title">
      <span class="fa fa-search"></span>
      <span class="text">
        资源搜索结果共
        <span style="color: red">{{
          searchResult ? searchResult.length : 0
        }}</span>
        条
      </span>
    </div>
    <div class="content">
      <ul v-if="topFiveData.length > 0">
        <li v-for="(item, index) in topFiveData" :key="index">
          <span class="index">{{ item.index }}</span>
          <img v-if="!item.cover" src="../../../assets/altimg.png" />
          <img v-if="item.cover" :src="item.cover" alt="未找到封面" />
          <div
            class="description"
            @click="locationFeature(item)"
            title="点击定位"
          >
            <div class="main">{{ item.name }}</div>
            <div class="detail">{{ item.gz }}</div>
          </div>
          <span
            class="angle fa fa-angle-right"
            @click="showDialog(item)"
          ></span>
        </li>
      </ul>
      <el-pagination
        style="text-align: center"
        layout="prev, pager, next"
        :page-size="5"
        :total="searchResult.length"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <SearchResultDialog
      ref="SearchResultDialog"
      v-show="searchResultDialogType == 2"
      :activeFeature="activeFeature"
    ></SearchResultDialog>
  </div>
</template>
<script>
import SearchResultDialog from "./SearchResultDialog.vue";
export default {
  name: "SearchResult",
  props: {
    searchResult: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      topFiveData: [],
      activeFeature: {}, //选中的文化点
    };
  },
  watch: {
    searchResult() {
      if (!this.searchResult) {
        return;
      }
      if (this.searchResult.length < 5) {
        this.topFiveData = this.searchResult;
      } else {
        this.topFiveData = this.searchResult.slice(0, 5);
      }
      this.topFiveData.forEach((feature) => {
        this.getTopFiveFeatureImg(feature);
      });
    },
  },
  computed: {
    searchResultDialogType() {
      return this.$store.state.searchResultDialogType;
    },
  },
  components: { SearchResultDialog },
  methods: {
    showDialog(item) {
      this.activeFeature = item;
      this.$store.commit("setSearchResultDialogType", 2);
      this.$refs.SearchResultDialog.toggleShow(true);
    },
    getTopFiveFeatureImg(feature) {
      if (/文物资源/.test(feature.type)) {
        this.getRelicDetail(feature);
      } else {
        this.getCultureDetail(feature);
      }
    },
    // 获取6类文化资源数据
    getCultureDetail(feature) {
      let params = {
        sno: feature.resoure,
        // sno: "040001",
      };
      this.$axios({
        url: "/chinacul/home/aajax/getcspoint",
        method: "get",
        params: params,
      }).then((res) => {
        let { code, data } = res.data;

        if (code === 0) {
          this.$set(feature, "cover", data.cover);
          this.$set(feature, "imglist", data.imglist);

          this.$set(feature, "address", data.address);
          this.$set(feature, "caidstr", data.caidstr);
          this.$set(feature, "longitude", data.longitude);
          this.$set(feature, "latitude", data.latitude);
          this.$set(feature, "altitude", data.altitude);
          this.$set(feature, "ccidstr", data.ccidstr);
          this.$set(feature, "levelname", data.levelname);
          this.$set(feature, "statetime", data.statetime);

          this.$set(feature, "desc", data.desc);
          this.$set(feature, "lswm", data.info_a);
          this.$set(feature, "ccfa", data.info_b);

          let booklist = data.booklist;
          let lswmFileList = [];
          let ccfaFileList = [];
          let jjFileList = [];
          let booklistData = [];
          if (booklist) { 
            for (let key in booklist) {
              let group = booklist[key];
              booklistData.push(group)
              if (group.lswm == 2) { 
                for (let j in group.filelist) {
                  lswmFileList.push(group.filelist[j]);
                }
              }
              if (group.ccfa == 2) { 
                for (let j in group.filelist) {
                  ccfaFileList.push(group.filelist[j]);
                }
              }
              if (group.jj == 2) { 
                for (let j in group.filelist) {
                  jjFileList.push(group.filelist[j]);
                }
              }
            }
          } 
          
          this.$set(feature, "booklistData", booklistData);
          this.$set(feature, "jjFileList", jjFileList);
          this.$set(feature, "lswmFileList", lswmFileList);
          this.$set(feature, "ccfaFileList", ccfaFileList);
        }
      });
    },
    // 获取地图文物详情
    getRelicDetail(feature) {
      let params = {
        sno: feature.resoure,
        // sno: "010001",
      };
      this.$axios({
        url: "/chinacul/home/aajax/getculturalrelic",
        method: "get",
        params: params,
      }).then((res) => {
        let { code, data } = res.data;

        if (code === 0) {
          this.$set(feature, "cover", data.cover);
          this.$set(feature, "imglist", data.imglist);

          this.$set(feature, "address", data.address);
          this.$set(feature, "longitude", data.longitude);
          this.$set(feature, "latitude", data.latitude);
          this.$set(feature, "levelname", data.levelname);
          this.$set(feature, "statetime", data.statetime);
          this.$set(feature, "desc", data.desc);
        }
      });
    },
    //点击文化点 地图自动定位
    locationFeature(item) {
      this.xxMap.location(item.geom);
    },
    //翻页
    currentChange(index) {
      let start = 5 * (index - 1);
      let total = this.searchResult.length;
      let end = 0;
      if (start + 5 < total) {
        end = start + 5;
      } else {
        end = total;
      }
      // this.topFiveData = this.searchResult.slice(start, end);
      // this.topFiveData.forEach((feature) => {
      //   this.getTopFiveFeatureImg(feature);
      // });
      let fiveData = this.searchResult.slice(start, end);
      fiveData = JSON.parse(JSON.stringify(fiveData));
      for (let i = 0; i < fiveData.length; i++) {
        if (!fiveData[i].cover) {
          this.getTopFiveFeatureImg(fiveData[i]);
        }
      }
      this.topFiveData = fiveData;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="less" >
.search-result {
  margin-top: 10px;
  .title {
    line-height: 35x;
    color: #355ba6;
    border-bottom: solid 1px #2390f7;

    .fa-search {
      padding: 0 5px;
      background-color: #2390f7;
      box-shadow: 0 1px #2390f7;
      color: #fff;
      text-align: center;
      font-weight: bold;
      line-height: 35px;
    }
  }
  .content {
    ul {
      list-style-type: none;
      padding-inline-start: 10px;
      li {
        height: 70px;
        padding-top: 5px;
        line-height: 60px;
        border-bottom: solid 1px #eee;

        .index {
          display: inline-block;
          width: 35px;
          text-align: center;
          background-image: url(../../../assets/searchIndex.png);
          background-size: 100% 90%;
          background-position-y: 57%;
          color: #fff;
          font-weight: bold;
        }
        img {
          display: inline-block;
          height: 60px;
          width: 80px;
          vertical-align: middle;
        }
        .description {
          display: inline-block;
          height: 60px;
          width: 320px;
          vertical-align: middle;
          padding-left: 10px;
          overflow: hidden;
          .main {
            width: 100%;
            line-height: 40px;
            word-break: keep-all;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .detail {
            line-height: 20px;
            width: 100%;
            font-size: small;
            color: rgb(110, 110, 110);
            word-break: keep-all;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        .description:hover {
          cursor: pointer;
          .main {
            color: #2390f7;
          }
          .detail {
            color: #6092c0;
          }
        }
        .angle {
          display: inline-block;
          width: 30px;
          font-size: xx-large;
          vertical-align: middle;
          color: #ccc;
          text-align: center;
          line-height: 60px;
          margin-bottom: -10px;
        }
        .angle:hover {
          cursor: pointer;
          color: rgb(138, 132, 132);
        }
      }
    }
  }
}
::v-deep.big-img-dialog {
  .el-dialog {
    margin-top: 0 !important;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
  }
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
    height: 100%;
    overflow: hidden;
  }
  .el-dialog {
    background-color: #070707ce !important;
    border-radius: 5px;
    padding: 10px;
  }
  .dialog-header {
    padding: 0 0 10px 0;
    .ctrl {
      float: right;

      span:nth-child(1) {
        padding: 0px 10px 0 5px;
        color: #f5f5f5;
        font-size: x-large;
      }
      span:hover {
        cursor: pointer;
        color: #efe1e1;
      }
    }
  }
  .content {
    height: calc(100% - 30px);
    overflow: hidden;
    text-align: center;
  }
}
::v-deep.search-detail-dialog {
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog {
    background-color: #185e9479 !important;
    border-radius: 5px;
    padding: 10px;
  }
}
.search-detail-dialog {
  .dialog-header {
    color: #fff;
    padding: 0 0 10px 0;
    .circle {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 30px;
      background-color: red;
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -2px;
    }
    .ctrl {
      float: right;
      span:nth-child(1) {
        padding: 0 5px 0 10px;
      }
      span:nth-child(2) {
        padding: 0px 10px 0 5px;
      }
      span:hover {
        cursor: pointer;
        color: #efe1e1;
      }
    }
  }
  .content {
    .left {
      display: inline-block;
      height: 460px;
      width: 210px;
      vertical-align: top;
      background-color: #fff;
      overflow: auto;
      .images {
        height: 110px;
        el-image img {
          width: 100%;
          height: 100%;
        }
      }
      .btns {
        color: #fff;
        padding: 10px;
        .item {
          background-color: #1265bd;
          margin-bottom: 5px;
          padding: 5px 10px 5px 20px;
          border-radius: 10px;
        }
        .item:hover {
          cursor: pointer;
          background-color: #2390f7;
        }
      }
      .base-info {
        color: #000;
        padding: 10px;
        .item {
          margin-bottom: 10px;
        }
      }
    }
    .right {
      display: inline-block;
      width: 460px;
      height: 460px;
      overflow: auto;
      color: #000;
      background-color: #fff;
      margin-left: 10px;
      padding: 10px 20px;
      .header {
        line-height: 40px;
        border-bottom: solid 1px #ccc;
        font-size: large;
        font-weight: bold;
        text-align: center;
      }
      .content {
        padding: 20px;
        text-align: center;
        font-family: fangsong sans-serif;
        .lon {
          margin-right: 20px;
        }
        .docs {
          text-indent: 0;
          text-align: center;
          .items {
            display: inline-block;
            font-size: 30px;
            border: solid 1px #eee;
            padding: 10px;
            width: 80px;
            max-height: 85px;
            overflow-y: hidden;
            .name {
              text-align: center;
              color: #595858;
              font-size: small;
              line-height: 15px;
            }
          }
          .items:nth-child(1) {
            margin-right: 10px;
            color: #307dff;
          }
          .items:nth-child(2) {
            margin-right: 10px;
            color: #ee635c;
          }
          .items:nth-child(3) {
            margin-right: 10px;
            color: #ff542b;
          }
          .items:nth-child(4) {
            margin-right: 10px;
            color: #307b54;
          }
        }
      }
      .guizhi,
      .wenmai,
      .chuancheng {
        .content {
          text-indent: 20px;
          line-height: 25px;
          text-align: left;
        }
      }
    }
  }
}
</style>

 